export default "__VITE_ASSET__Dg8qSZue__"